import * as React from "react";
import ProjectDetails from "./ProjectDetails";
const galleryImages = [{
  id: 1,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Anexartisias-6-scaled.jpg?v=3man0hjz3xf",
  alt: "Pareklisia residence exterior view"
}, {
  id: 2,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Anexartisias-3-scaled.jpg?v=e5xew92z0v",
  alt: "Interior living room renovation"
}, {
  id: 3,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Anexartisias-4-scaled.jpg?v=v81sy718gqb",
  alt: "Modern kitchen remodel"
}, {
  id: 4,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Anexartisias-2-scaled.jpg?v=hlhdfl18ra6",
  alt: "Master bedroom interior design"
}, {
  id: 5,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Anexartisias-5-scaled.jpg?v=irts9m6wpj9",
  alt: "Luxury bathroom renovation"
}, {
  id: 6,
  src: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Anexartisias-1-scaled.jpg?v=zdlqzfs70pi",
  alt: "Outdoor terrace and garden"
}];
export default function ProjectHeroImage() {
  return <section id="project-hero-image" className="bg-[#ff] py-12">
      <div className="w-full px-8 max-w-[1920px] mx-auto">
        <h1 className="text-center font-bold mb-10 !text-[27px]">Anexartisias Apartment Building Renovation</h1>
        <ProjectDetails />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, i) => <div key={image.id} data-index={i} className="overflow-hidden rounded-[0.5rem] bg-muted/20">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover aspect-[4/3] transition-transform duration-500 hover:scale-105" loading={i < 3 ? "eager" : "lazy"} />
            </div>)}
        </div>
      </div>
    </section>;
}